<template>
  <div v-if="showTopBorder" class="h-px w-full bg-grey-35"></div>
  <div class="flex justify-between text-base font-semibold text-indigo-500">
    <div class="flex cursor-pointer gap-1">
      <slot class="left">
        <button class="flex gap-x-1" @click="leftCallback">
          <div v-if="leftText" class="flex size-6 min-h-6 min-w-6 items-center justify-center">
            <zoom-in class="*:fill-indigo-500" />
          </div>

          <p class="select-none">{{ leftText }}</p>
        </button>
      </slot>
    </div>

    <button v-if="rightText" class="cursor-pointer select-none" @click="rightCallback">{{ rightText }}</button>
  </div>
</template>

<script setup lang="ts">
import ZoomIn from '@/common/assets/icons/zoom-in.svg';
import { i18n } from '@/locales';

withDefaults(
  defineProps<{
    showTopBorder?: boolean;

    leftText?: string;

    rightText?: string;

    leftCallback?: () => void;

    rightCallback?: () => void;
  }>(),
  {
    showTopBorder: true,

    leftText: i18n.global.t('lSeWusNweldd_c1g_1aJb'),
    rightText: undefined,

    leftCallback: undefined,
    rightCallback: undefined,
  }
);
</script>
